var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-table',_vm._g(_vm._b({},'el-table',_vm.$attrs,false),_vm.$listeners),_vm._l((_vm.columns),function(item){return _c('ElTableWrapColumn',{key:item.key || item.prop,attrs:{"column":item}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }